export default __webpack_public_path__ + "static/media/downInActive.eb548e94.svg";